import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd8f8128"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-form__item" }
const _hoisted_2 = { class: "custom-font-text" }
const _hoisted_3 = { class: "fallback-strategy__text-title" }

import {useRouter} from 'vue-router';
    import {computed, ref} from 'vue';
    import {useStore} from 'vuex';
    import {useTranslation} from '@malt/vue3-use';
    import UseCaseSide from '@/profile-creation-wizard/components/for-creation/ui/useCase/UseCaseSide.vue';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import {StrategyBackground} from '@/profile-creation-wizard/types';
    import {linkToMarketplace} from '@/profile-creation-wizard/router/funnelSwitch';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {inject} from 'vue';
    import ReroutingTransition from '@/profile-creation-wizard/components/for-creation/ui/ReroutingTransition.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'UseCaseStep',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();
    const trackingRepository = inject(DI.trackingRepository);

    const selectedBackground = computed(() => store.getters[getters.selectedBackground]);

    const managementChecked = computed(() => selectedBackground.value.managementConsultant);
    const executiveChecked = computed(() => selectedBackground.value.interimExecutive);
    const isStepValid = computed(() => managementChecked.value || executiveChecked.value);
    const image = {height: '108', width: '83', alt: 'choice', src: '//dam.malt.com/profile/signup/choice.svg?vh=85f406'};
    const showTransition = ref(false);

    function managementChange(event: CustomEvent): void {
        save({managementConsultant: event.detail, interimExecutive: executiveChecked.value});
    }

    function executiveChange(event: CustomEvent): void {
        save({managementConsultant: managementChecked.value, interimExecutive: event.detail});
    }

    function save(background: StrategyBackground): void {
        store.commit(mutations.updateStrategyBackground, background);
    }

    function goNext(): void {
        trackingRepository?.track('use-case-input-strategy', {
            strategyBackground: Object.keys(selectedBackground.value).filter((key) => selectedBackground.value[key]),
        });
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

    function reroute(): void {
        trackingRepository?.track('funnel-redirection-strategy', {
            reason: 'describe-yourself',
        });
        showTransition.value = true;
        setTimeout(redirect, 3000);
    }

    function redirect() {
        window.location.href = linkToMarketplace(router.currentRoute.value.path);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_checkbox = _resolveComponent("joy-checkbox")!
  const _component_joy_separator = _resolveComponent("joy-separator")!
  const _component_joy_link = _resolveComponent("joy-link")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Step, {
      "is-step-valid": isStepValid.value,
      onGoToNext: goNext
    }, {
      "step-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.title')), 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.subtitle')), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["selectable-option", {selected: managementChecked.value}])
          }, [
            _createVNode(_component_joy_checkbox, {
              checked: managementChecked.value,
              "data-testid": "strategy-profile-creation-use-case-management-consultant-checkbox",
              onValueChange: managementChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.management.title')), 1)
              ]),
              _: 1
            }, 8, ["checked"]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.description.requirement')), 1),
              _createElementVNode("dd", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.management.requirement1')), 1)
                ])
              ]),
              _createElementVNode("dt", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.description.opportunities')), 1),
              _createElementVNode("dd", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.management.opportunity1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.management.opportunity2')), 1)
                ])
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["selectable-option", {selected: executiveChecked.value}])
          }, [
            _createVNode(_component_joy_checkbox, {
              checked: executiveChecked.value,
              "data-testid": "strategy-profile-creation-use-case-interim-executive-checkbox",
              onValueChange: executiveChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.executive.title')), 1)
              ]),
              _: 1
            }, 8, ["checked"]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.description.requirement')), 1),
              _createElementVNode("dd", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.executive.requirement1')), 1)
                ])
              ]),
              _createElementVNode("dt", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.description.opportunities')), 1),
              _createElementVNode("dd", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.executive.opportunity1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.executive.opportunity2')), 1)
                ])
              ])
            ])
          ], 2),
          _createVNode(_component_joy_separator, {
            class: "divider",
            text: "or"
          }),
          _createVNode(_component_VJoyWrapper, {
            class: "fallback-strategy",
            wrap: "nowrap",
            "no-margin": "",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", _normalizeProps(_guardReactiveProps(image)), null, 16),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.rerouting.title')), 1),
                _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.rerouting.description')), 1),
                _createElementVNode("p", null, [
                  _createVNode(_component_joy_link, { onClick: reroute }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.use.case.rerouting.link')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      "step-side": _withCtx(() => [
        _createVNode(UseCaseSide)
      ]),
      _: 1
    }, 8, ["is-step-valid"]),
    (showTransition.value)
      ? (_openBlock(), _createBlock(ReroutingTransition, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})